<template>
	<div class="animated fadeIn">
		<loading :active.sync="isLoading"></loading>
		<b-row>
			<b-col lg="12">
				<b-card>
					<div slot="header">
						<i class='icon-layers'></i> Zaloga vozil
						<div class="card-actions">
							<a v-if="!exportActive" class="btn btn-primary text-Secondary" title="Izvozi vozila" @click.prevent="toggleExportActive"><i class="icon-cloud-download"></i></a>
							<a v-if="exportActive" :class="(exportAll || selectedItems.length > 0) ? 'text-success btnConfirmExport' : 'text-danger btnConfirmExport'">{{ (exportAll || selectedItems.length > 0) ? 'Izvoz ' + (exportAll ? totalRows : selectedItems.length) + ' vozil' : 'Izbrano mora biti vsaj 1 vozilo' }}</a>
							<a v-if="exportActive && (exportAll || selectedItems.length > 0)" class="btn btn-primary text-success" title="Potrdi izvoz'" @click.prevent="exportImportData"><i class="icon-check"></i></a>
							<a v-if="exportActive" class="btn btn-primary text-danger" title="Prekliči izvoz" @click.prevent="toggleExportActive"><i class="icon-close"></i></a>
							<a v-if="!exportActive" class="btn btn-setting btnArhiv"><b-form-checkbox v-model="inputFilter.arhiv" @change="arhiv_Changed">Arhiv</b-form-checkbox></a>
							<a v-if="!exportActive" class="btn btn-setting btnNissan"><b-form-checkbox v-model="inputFilter.nissan" @change="nissan_Changed">Nissan</b-form-checkbox></a>
							<a v-if="!exportActive" href="#odstraniFilter" class="btn btn-setting" title="Ponastavi filtre" @click.prevent="click_clearTableFilter"><i class="icon-action-undo"></i></a>
							<a v-if="!exportActive" href="#osveziPodatke" class="btn btn-setting text-warning" title="Uvozi Renault in Dacia" @click.prevent="click_openPopulateDataModal"><i class="icon-cloud-upload"></i></a>
							<a v-if="!exportActive" href="#uploadNissan" class="btn btn-primary text-info" title="Uvozi Nissan" @click.prevent="click_openPopulateNissanModal"><i class="icon-cloud-upload"></i></a>
							<a v-if="!exportActive" href="#osveziVega" class="btn btn-setting text-primary" title="Uvozi Vega" @click.prevent="click_openPopulateVegaModal"><i class="icon-cloud-upload"></i></a>
							<a v-if="!exportActive" href="#dodajVozilo" class="btn btn-setting" title="Ročno dodaj vozilo" @click.prevent="click_addNew"><i class="icon-plus"></i></a>						
						</div>
					</div>
					<b-container fluid>
						<b-row class="mb-3">
							<b-col>
								<b-form-group>
									<label>Prodajalec</label>
									<v-select ref="prodajalci"
										v-model="prodajalec_selected"
										:options="prodajalci_options"
										label="full_name"
										@input="prodajalci_Changed"
										placeholder="Izberi prodajalca ...">
									</v-select>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group>
									<label>Kupec</label>
									<v-select ref="kupci"
										v-model="kupec_selected"
										:options="kupci_searched"
										label="full_name"
										@input="kupciSelect_change"
										@search="kupciSelect_search"
										placeholder="Izberi kupca ...">
										<template slot="no-options">Kupec ni najden</template>
									</v-select>
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group>
									<label style="margin-bottom:5px;">Planirana dobava</label>
									<br />
									<datum-filter-dropdown ref="obljubljenaDobavaDropdown" v-model="inputFilter.obljubljenaDobava" v-bind:compact="false" default_label="Izberi obdobje ..." @input="onInputChange" />
								</b-form-group>
							</b-col>
							<b-col>
								<b-form-group class="advanced_filter_lokacije">
								</b-form-group>
							</b-col>
							<b-col></b-col>
							<b-col></b-col>
						</b-row>
					</b-container>
					<b-table
						ref="dataTable" 
						responsive="sm"
						show-empty
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						:items="dataProvider"
						:fields="fields"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						:tbody-tr-class="rowClass"
						@sort-changed="sortingChanged"
						@filtered="onFiltered"
						@row-clicked="rowClicked">
						<template slot="selected" slot-scope="data">
							<b-form-checkbox :disabled="exportAll" :checked="exportAll ? true : data.item.selected" @change="selectItem_change(data.item)"></b-form-checkbox>
						</template>
						<template slot="libelle_version" slot-scope="data">
							<div class="model_version" :title="getTitle(data.item.libelle_version)" v-b-tooltip.hover>{{ data.item.libelle_version | model_short_version }}</div>
						</template>
						<template slot="libelle_options" slot-scope="data">
							<b-badge v-if="data.item.libelle_options != '' && data.item.libelle_options != 'null' && data.item.libelle_options != null" variant="" :title="getTitle(data.item.libelle_options)" v-b-tooltip.hover><i class="i_options fa fa-gears fa-lg" style="padding:2px;"></i></b-badge>
							<b-badge v-if="data.item.libelle_teinte != '' && data.item.libelle_teinte != 'null' && data.item.libelle_teinte != null" variant="" :title="getTitle(data.item.libelle_teinte)" v-b-tooltip.hover>
								<span v-if="data.item.barva != '' && data.item.barva != 'null' && data.item.barva != null" style="line-height:20px;">{{ data.item.barva }}</span>
								<span v-else style="line-height:20px;"><i class="fa fa-tint" style="margin-left:5px; margin-right:5px"></i></span>
							</b-badge>
						</template>
						<template slot="status" slot-scope="data">
							<b-badge v-if="isReserved(data.item)" variant="danger" :title="getReservationInfo(data.item)" v-b-tooltip.hover>Rezervirano</b-badge>
							<b-badge v-if="isSold(data.item)" variant="success" :title="getSoldInfo(data.item)" v-b-tooltip.hover>Prodano</b-badge>
							<b-badge v-if="isKoncesija(data.item)" variant="warning" :title="getKoncesijaInfo(data.item)" v-b-tooltip.hover>{{ data.item | koncesija_label }}</b-badge>
						</template>
						<template v-if="!exportActive" slot="actions" slot-scope="data">
							<b-button size="sm" @click.stop="click_reserveItem(data.item.id)" class="mr-1 mb-1" :disabled="isReservedDisabled(data.item.has_reservation, data.item.has_sold)">Rezerviraj</b-button>
							<b-button size="sm" @click.stop="click_sellItem(data.item)" class="mr-1 mb-1" :class="{ disabled: isSold(data.item) }" variant="primary">Prodaj</b-button>
							<b-button size="sm" @click.stop="click_dobavavKoncesijo(data.item)" class="mr-1 mb-1" :class="{ disabled: isKoncesija(data.item) }" variant="warning">DK</b-button>
						</template>
						<template slot="top-row">
							<td v-if="exportActive"><b-form-checkbox v-model="exportAll"></b-form-checkbox></td>
							<td><konto-filter-dropdown ref="kontoDropdown" @change="on_kontoFilterChange" /></td>
							<td><b-form-input v-model="inputFilter.vega_dhsVegaSalesId" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.st_narocila_kupca" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.st_narocila_vozila" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.ogrodje" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.vega_brand" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.model" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.verzija" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.barva" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.predvideni_mada" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.vega_status" type="text" @input="onInputChange" /></td>
							<td><b-form-input v-model="inputFilter.staranje" type="text" @input="onInputChange" /></td>
							<td>
								<status-filter-dropdown ref="statusDropdown" @change="on_statusFilterChange" />
								<prodaja-filter-dropdown v-show="isProdajaDropdownVisible" ref="prodajaDropdown" @change="on_prodajaFilterChange" />
								<lokacije-filter-dropdown v-show="isLokacijeDropdownVisible" ref="lokacijeDropdown" @change="on_lokacijeFilterChange" />
							</td>
							<td></td>
						</template>
						<template slot="row-details" slot-scope="row">
							<podrobnosti-vozila-zaloga-card ref="PodrobnostiVozilaZalogaCard" v-bind:item="row.item" v-if="row.item.source_file == 'zaloga'"/>
							<podrobnosti-vozila-card ref="PodrobnostiVozilaCard" v-bind:item="row.item" v-else/>
							<b-row class="mb-2">
								<b-col sm="2" class="text-sm-right"><b>Opomba:</b></b-col>

								<b-col sm="4"><div class="opomba_input_box">{{ row.item.interna_opomba }}</div></b-col>
								<b-col sm="4"><b-button size="sm" @click.stop="click_editOpomba(row, $event.target)">Uredi</b-button></b-col>

								<b-col sm="2"></b-col>
							</b-row>
							<b-row class="mb-2">
								<b-col sm="4" class="text-sm-left">
									<b-button size="sm" @click.stop="click_showInfo(row, $event.target)">Podrobnosti</b-button>
									<b-button size="sm" @click.stop="click_showMapa(row, $event.target)">Mapa</b-button>
									<b-button v-if="row.item.st_narocila_kupca == '' && row.item.has_sold && allowStorno()" size="sm" @click.stop="click_stornirajProdajo(row.item.has_sold)" variant="primary">Storniraj</b-button>
									<b-button v-if="row.item.st_narocila_kupca == '' && row.item.has_reservation && allowStorno()" size="sm" @click.stop="click_stornirajRezervacijo(row.item.has_reservation)" variant="danger">Storniraj</b-button>
									<b-button v-if="row.item.st_narocila_kupca == '' && (row.item.konto_destinacije == 'CENNM' || row.item.konto_destinacije == 'SVNCENNM' || row.item.konto_destinacije == 'SIDCENNM')" size="sm" @click.stop="click_zadrzano(row.item.id)">Zadržano</b-button>
									<b-button v-if="showDeleteButton(row.item)" variant="danger" size="sm" @click.stop="clicl_deleteImportdata(row.item)">Izbriši</b-button>
									<b-button v-if="showArchiveButton(row.item)" variant="warning" size="sm" @click.stop="click_archiveImportdata(row.item)">Arhiviraj</b-button>
								</b-col>

								<b-col sm="2"></b-col>
								<b-col sm="2"></b-col>

								<b-col sm="2"></b-col>
								<b-col sm="2" class="text-sm-right">
									<b-button size="sm" @click="row.toggleDetails">Zapri</b-button>
								</b-col>
							</b-row>
						</template>
					</b-table>
					<nav>
						<b-row>
							<b-col sm="10">
								<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prejšnja" next-text="Naslednja" :limit="naviLimit" hide-goto-end-buttons />
							</b-col>
							<b-col sm="2">
								<a class="page-link rows_total">Št. vrstic: {{totalRows}}</a>
							</b-col>
						</b-row>
					</nav>
				</b-card>

				<populate-data-modal ref="populateDataModal" v-on:data-updated="on_dataUpdated" />
				<populate-vega-modal ref="populateVegaModal" v-on:data-updated="on_dataUpdated" />
				<populate-nissan-modal ref="populateNissanModal" v-on:data-updated="on_dataUpdated" />
				<rezerviraj-vozilo-modal ref="rezervirajVoziloModal" :prodajalci="prodajalci_options" :kupci="kupci_options" v-on:reservation-success="on_reservationSuccess" />
				<prodaj-vozilo-modal ref="prodajVoziloModal" :prodajalci="prodajalci_options" :kupci="kupci_options" v-on:sell-success="on_sellSuccess" />
				<dobava-v-koncesijo-modal ref="dobavavKoncesijoModal" v-on:prodajavkoncesijo-success="on_prodajavkoncesijoSuccess" />
				<zadrzano-modal ref="zadrzanoModal" v-on:zadrzano-success="on_zadrzanoSuccess" />
				<opomba-vozila-modal ref="opombaVozilaModal" v-on:opomba-success="on_opombaSuccess" />
				<mapa-modal ref="mapaModal" />
				<podrobnosti-vozila-modal ref="podrobnostiVozilaModal" @importdata_add="importdata_add" @importdata_edit="importdata_edit"/>
				
			</b-col>
		</b-row>
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>
<script>
import PopulateDataModal from '@/components/PopulateDataModal';
import PopulateVegaModal from '@/components/PopulateVegaModal';
import PopulateNissanModal from '@/components/PopulateNissanModal';
import RezervirajVoziloModal from '@/components/RezervirajVoziloModal';
import ProdajVoziloModal from '@/components/ProdajVoziloModal';
import DobavavKoncesijoModal from '@/components/DobavavKoncesijoModal';
import ZadrzanoModal from '@/components/ZadrzanoModal';
import StanjeFilterDropdown from '@/components/StanjeFilterDropdown';
import StatusFilterDropdown from '@/components/StatusFilterDropdown';
import LokacijeFilterDropdown from '@/components/LokacijeFilterDropdown';
import ProdajaFilterDropdown from '@/components/ProdajaFilterDropdown';
import OpombaVozilaModal from '@/components/OpombaVozilaModal';
import MapaModal from '@/components/MapaModal';
import PodrobnostiVozilaModal from '@/components/PodrobnostiVozilaModal';
import PodrobnostiVozilaZalogaCard from '@/components/PodrobnostiVozilaZalogaCard';
import PodrobnostiVozilaCard from '@/components/PodrobnostiVozilaCard';
import DatumFilterDropdown from '@/components/DatumFilterDropdown';
import KontoFilterDropdown from '@/components/KontoDestinacijeFilterDropdown';
import service from '@/service';
import { format, parse } from 'date-fns';
import settings from '@/settings.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'lodash';

const fb = require('@/firebase.config.js');

export default {
	name: 'tabla',
	components: {
		Loading,
		'populate-data-modal': PopulateDataModal,
		'populate-vega-modal': PopulateVegaModal,
		'populate-nissan-modal': PopulateNissanModal,
		'rezerviraj-vozilo-modal': RezervirajVoziloModal,
		'prodaj-vozilo-modal': ProdajVoziloModal,
		'dobava-v-koncesijo-modal': DobavavKoncesijoModal,
		'zadrzano-modal': ZadrzanoModal,
		'stanje-filter-dropdown': StanjeFilterDropdown,
		'status-filter-dropdown': StatusFilterDropdown,
		'lokacije-filter-dropdown': LokacijeFilterDropdown,
		'prodaja-filter-dropdown': ProdajaFilterDropdown,
		'opomba-vozila-modal': OpombaVozilaModal,
		'datum-filter-dropdown': DatumFilterDropdown,
		'konto-filter-dropdown': KontoFilterDropdown,
		'mapa-modal': MapaModal,
		'podrobnosti-vozila-modal': PodrobnostiVozilaModal,
		'podrobnosti-vozila-zaloga-card': PodrobnostiVozilaZalogaCard,
		'podrobnosti-vozila-card': PodrobnostiVozilaCard
	},
	filters: {
		model_short_version: function (value) {
			if (value) {
				if (value.length > 55) {
					return value.substring(0, 53) + '...';
				} else {
					return value;
				}
			} else {
				return '';
			}
		},
		koncesija_label: function (item) {
			if (item && item.koncesija_lokacija) {
				return 'V koncesiji (' + item.koncesija_lokacija + ')';
			}
			return 'V koncesiji';
		},
		akcija_dane: function (value) {
			if (value) {
				return 'Da';
			} else {
				return 'Ne';
			}
		}
	},
	methods: {
		onInputChange: function (value) {
			if (this.filterImportdataTimeout !== null) {
				clearTimeout(this.filterImportdataTimeout);
			}
			this.filterImportdataTimeout = setTimeout(() => {
				this.$refs.dataTable.refresh();
			}, settings.filterTimeoutLength);
		},
		prodajalci_Changed (prodajalec) {
			if (prodajalec) {
				this.inputFilter.prodajalec = prodajalec.id;
			} else {
				this.inputFilter.prodajalec = null;
			}
			this.$refs.dataTable.refresh();
		},
		kupci_Changed (kupec) {
			if (kupec) {
				this.inputFilter.kupec = kupec.id;
			} else {
				this.inputFilter.kupec = null;
			}
			this.$refs.dataTable.refresh();
		},
		arhiv_Changed (arhiv) {
			this.$refs.dataTable.refresh();
		},
		nissan_Changed (nissan) {
			this.$refs.dataTable.refresh();
		},
		getSoldInfo (item) {
			if (!item || !item.has_sold) {
				return '';
			}
			let hs = 'Prodajalec: ' + item.p_prodajalec_name + ';';
			let kupecHr = this.getKupecHR(item.p_kupec, item.p_is_company, item.p_kupec_name, item.p_company);
			if (kupecHr != null) {
				hs += ' Kupec: ' + kupecHr + ';';
			}
			let datumProdaje = parse(item.p_datum_prodaje, settings.dbDtFormat);
			hs += ' Datum prodaje: ' + format(datumProdaje, settings.hrsDtFormat);
			return hs;
		},
		isSold (item) {
			if (!item || !item.has_sold) {
				return false;
			}
			return true;
		},
		getReservationInfo (item) {
			if (!item || !item.has_reservation) {
				return '';
			}
			let hs = 'Prodajalec: ' + item.r_prodajalec_name + ';';
			let kupecHr = this.getKupecHR(item.r_kupec, item.r_is_company, item.r_kupec_name, item.r_company);
			if (kupecHr != null) {
				hs += ' Kupec: ' + kupecHr + ';';
			}
			let datumOd = parse(item.r_reserved_from, settings.dbDtFormat);
			let datumDo = parse(item.r_reserved_to, settings.dbDtFormat);
			hs += ' Od: ' + format(datumOd, settings.hrsDtFormat) + '; Do: ' + format(datumDo, settings.hrsDtFormat);
			return hs;
		},
		isReserved (item) {
			if (!item || !item.has_reservation) {
				return false;
			}
			return true;
		},
		isReservedDisabled (reserved, sold) {
			if (sold != null || reserved != null) {
				return true;
			}
			return false;
		},
		getKoncesijaInfo (item) {
			if (!item || !item.koncesija_datum) {
				return '';
			}
			let hs = 'Lokacija: ' + item.koncesija_lokacija + ';';
			if (item.koncesija_prodajalec != null) {
				hs += ' Prodajalec: ' + item.koncesija_prodajalec_name + ';';
			}
			let datumKoncesije = parse(item.koncesija_datum, settings.dbDtFormat);
			hs += ' Datum: ' + format(datumKoncesije, settings.hrsDtFormat);
			return hs;
		},
		isKoncesija (item) {
			if (!item || !item.koncesija_datum) {
				return false;
			}
			return true;
		},
		getKupecHR (id, isCompany, name, title) {
			if (id == null) {
				return null;
			}
			if (isCompany) {
				return title;
			}
			return name;
		},
		getTitle (value) {
			return value;
		},
		rowClicked (row, index) {
			if (this.exportActive) {
				this.selectItem_change(row);
			} else {
				row._showDetails = !row._showDetails;
			}
		},
		sortingChanged: function (ctx) {
			console.log('sort');
			console.log(ctx);
			// ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
			// ctx.sortDesc ==> true if sorting descending, false otherwise
		},
		onFiltered: function (filteredItems) {
			console.log('filter');
			console.log(filteredItems);
			// this.totalRows = filteredItems.length;
			// this.currentPage = 1;
		},
		rowClass: function (item, type) {
			if (!item) {
				return '';
			}
			if (item.akcijski === 1) {
				return 'table-warning';
			}
			if (item.konto_destinacije === 'TV' || item.konto_destinacije === 'RV0KM' || item.konto_destinacije === 'ND') {
				return 'table-info';
			}
			return '';
		},
		click_clearTableFilter: function () {
			this.resetFilter();
			this.resetFilterForms();
			this.$refs.dataTable.refresh();
		},
		click_openPopulateDataModal: function () {
			this.$refs.populateDataModal.showModal();
		},
		click_openPopulateVegaModal: function () {
			this.$refs.populateVegaModal.showModal();
		},
		click_openPopulateNissanModal: function () {
			this.$refs.populateNissanModal.showModal();
		},
		click_reserveItem: function (value) {
			this.$refs.rezervirajVoziloModal.showModal(value);
		},
		click_sellItem: function (item) {
			let kupecHr = this.getKupecHR(item.p_kupec, item.p_is_company, item.p_kupec_name, item.p_company);
			this.$refs.prodajVoziloModal.showModal(
				item.id,
				item.has_sold,
				item.p_prodajalec,
				item.p_kupec,
				item.p_datum_prodaje,
				item.p_datum_planirane_dobave,
				item.p_urejeno_financiranje,
				item.p_vlozeno,
				item.p_podpisano,
				item.p_financiranje_rci,
				item.p_external,
				kupecHr
			);
		},
		click_dobavavKoncesijo: function (item) {
			this.$refs.dobavavKoncesijoModal.showModal(item.id, item.koncesija_lokacija, item.koncesija_datum);
		},
		click_stornirajProdajo: function (prodajaId) {
			if (prodajaId) {
				service.stornirajProdajo(prodajaId)
					.then(response => {
						this.$refs.dataTable.refresh();
						this.updateTable = false;
						fb.db.ref('importdata').set({
							updated_on: new Date().getTime()
						});
					})
					.catch(error => {
						if (error) {
							console.log(error);
						}
					});
			}
		},
		click_stornirajRezervacijo: function (rezervacijaId) {
			if (rezervacijaId) {
				service.stornirajRezervacijo(rezervacijaId)
					.then(response => {
						this.$refs.dataTable.refresh();
						this.updateTable = false;
						fb.db.ref('importdata').set({
							updated_on: new Date().getTime()
						});
					})
					.catch(error => {
						if (error) {
							console.log(error);
						}
					});
			}
		},
		click_zadrzano: function (value) {
			this.$refs.zadrzanoModal.showModal(value);
		},
		click_editOpomba: function (row, button) {
			this.$refs.opombaVozilaModal.showModal(row.item.id, row.item.interna_opomba, row.item.akcijski);
		},
		click_showMapa: function (row, button) {
			let vozilo = row.item.libelle_modele + ' ' + row.item.libelle_version;
			let kupec = this.getKupecHR(row.item.p_kupec, row.item.p_is_company, row.item.p_kupec_name, row.item.p_company);
			this.$refs.mapaModal.showModal(
				row.item.id,
				row.item.ogrodje,
				vozilo,
				row.item.p_prodajalec,
				row.item.p_prodajalec_name,
				kupec,
				0,
				row.item.p_datum_prodaje,
				row.item.p_datum_planirane_dobave,
				row.item.p_financiranje_rci,
				row.item.koncesija_datum,
				false
			); //
		},
		on_dataUpdated: function () {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_reservationSuccess: function () {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_sellSuccess: function () {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_prodajavkoncesijoSuccess: function () {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_zadrzanoSuccess: function () {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		on_opombaSuccess: function () {
			this.$refs.dataTable.refresh();
			this.updateTable = false;
			fb.db.ref('importdata').set({
				updated_on: new Date().getTime()
			});
		},
		dataProvider: function (ctx) {
			this.isLoading = true;
			return service.getVozilaFiltered(ctx, this.inputFilter, this.user)
				.then(data => {
					this.isLoading = false;
					this.items = data;
					this.totalRows = data.total;
					if (this.exportActive) {
						this.checkSelectedItems();
					}
					return this.items.data;
				})
				.catch(error => {
					if (error) {
						console.log(error);
						this.isLoading = false;
					}
					return [];
				});
		},
		click_showInfo: function (data, button) {
			this.$refs.podrobnostiVozilaModal.showModal(
				data.item
			);
		},
		on_stanjeFilterChange: function (selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.stanje = [];
				for (let item of selectedItems) {
					this.inputFilter.stanje.push(item.value);
				}
			} else {
				this.inputFilter.stanje = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_statusFilterChange: function (selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.status = [];
				let resetLokacije = true;
				let resetProdaja = true;
				for (let item of selectedItems) {
					if (item.value === 'konces') {
						resetLokacije = false;
					} else if (item.value === 'prod') {
						resetProdaja = false;
					}
					this.inputFilter.status.push(item.value);
				}
				// reset lokacije
				if (resetLokacije) {
					this.inputFilter.lokacije = null;
					this.$refs.lokacijeDropdown.clear();
				}
				// reset prodaja
				if (resetProdaja) {
					this.inputFilter.prodaja = null;
					this.$refs.prodajaDropdown.clear();
				}
			} else {
				this.inputFilter.status = null;
				this.inputFilter.lokacije = null;
				this.$refs.lokacijeDropdown.clear();
				this.inputFilter.prodaja = null;
				this.$refs.prodajaDropdown.clear();
			}
			this.$refs.dataTable.refresh();
		},
		on_kontoFilterChange: function (selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.konto_destinacije = [];
				for (let item of selectedItems) {
					this.inputFilter.konto_destinacije.push(item.value);
				}
			} else {
				this.inputFilter.konto_destinacije = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_lokacijeFilterChange: function (selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.lokacije = [];
				for (let item of selectedItems) {
					this.inputFilter.lokacije.push(item.value);
				}
			} else {
				this.inputFilter.lokacije = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_prodajaFilterChange: function (selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.prodaja = [];
				for (let item of selectedItems) {
					this.inputFilter.prodaja.push(item.value);
				}
			} else {
				this.inputFilter.prodaja = null;
			}
			this.$refs.dataTable.refresh();
		},
		allowStorno: function () {
			if (this.user.role === 4 || this.user.role === 5) {
				return true;
			} else {
				return false;
			}
		},
		resetFilter: function () {
			this.prodajalec_selected = null;
			this.kupec_selected = null;
			this.inputFilter = {
				konto_destinacije: null,
				st_narocila_kupca: '',
				st_narocila_vozila: '',
				ogrodje: '',
				model: '',
				verzija: '',
				barva: '',
				staranje: '',
				stanje: null,
				status: null,
				lokacije: null,
				prodaja: null,
				prodajalec: null,
				kupec: null,
				rmadc: null,
				pmadc: null,
				omada: null,
				pdp: null,
				obljubljenaDobava: null,
				arhiv: false,
				nissan: false,
				vega_dhsVegaSalesId: '',
				vega_brand: '',
				vega_status: '',
				predvideni_mada: ''
			};
		},
		resetFilterForms: function () {
			this.$refs.stanjeDropdown.clear();
			this.$refs.statusDropdown.clear();
			this.$refs.lokacijeDropdown.clear();
			this.$refs.prodajaDropdown.clear();
			this.$refs.rmadcDropdown.clear();
			this.$refs.pmadcDropdown.clear();
			this.$refs.omadaDropdown.clear();
			this.$refs.pdpDropdown.clear();
			this.$refs.obljubljenaDobavaDropdown.clear();
		},
		click_addNew: function () {
			this.$refs.podrobnostiVozilaModal.showModal(null);
		},
		importdata_add: function (data) {
			this.$refs.dataTable.refresh();
			let message = '';
			if (data.ogrodje !== '') {
				message = 'Vozilo ' + data.ogrodje + ' (#' + data.id + ') uspešno dodano.';
			} else {
				message = 'Vozilo #' + data.id + ' uspešno dodano.';
			}
			this.$refs.toastr.s(message);
		},
		importdata_edit: function (data) {
			console.log('data', data)
			this.$refs.dataTable.refresh();
			let message = '';
			if (data.ogrodje !== '') {
				message = 'Vozilo ' + data.ogrodje + ' (#' + data.id + ') uspešno urejeno.';
			} else {
				message = 'Vozilo #' + data.id + ' uspešno urejeno.';
			}
			this.$refs.toastr.s(message);
		},
		showDeleteButton: function (data) {
			if (data.source_file === 'manual') {
				return true;
			}
			return false;
		},
		showArchiveButton: function () {
			if (this.user.role === 1 || this.user.role === 5) {
				return true;
			} else {
				return false;
			}
		},
		click_archiveImportdata: function (importdata) {
			this.$bvModal.msgBoxConfirm('Želite arhivirati vozilo ' + importdata.ogrodje + ' (#' + importdata.id + ')?', {
				title: 'Potrdite arhiviranje vozila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					service.archiveImportdata(importdata.id)
						.then(response => {
							if (response.message === 'archived') {
								this.$refs.toastr.s('Vozilo ' + response.archived_importdata.ogrodje + ' (#' + response.archived_importdata.id + ') arhivirano.');
								this.$refs.dataTable.refresh();
							} else {
								this.$refs.toastr.e('Neveljaven odziv strežnika!');
								console.error('Neveljaven response message: ' + response.message);
							}
						})
						.catch(error => {
							if (error.response) {
								// Request made and server responded
								if (error.response.data.message === 'serverSideValidationError') {
									this.$refs.toastr.e('Napaka pri validaciji na strežniku!');
									console.error(error.response.data.message + ': ', error.response.data.errors);
								} else if (error.response.data.message === 'notFoundError') {
									this.$refs.toastr.e('Vozila #' + error.response.data.wrong_archived_id + ' ni mogoče najti!');
									console.error(error.response.data.message);
								} else if (error.response.data.message === 'notArchivedError') {
									this.$refs.toastr.e('Napaka pri arhiviranju vozila #' + error.response.data.wrong_archived_id + '!');
									console.error(error.response.data.message);
								} else if (error.response.data.message === 'PDOException') {
									this.$refs.toastr.e('Napaka pri podatkovni bazi!');
									console.error(error.response.data.message, 'details in .ex');
								} else {
									this.$refs.toastr.e('Neznana napaka na strežniku!');
									console.error(error.response.data.message);
								}
							} else if (error.request) {
								// The request was made but no response was received
								this.$refs.toastr.e('Napaka: strežnik se ni odzval!');
								console.log('The request was made but no response was received:', error.request);
							} else {
								// Something happened in setting up the request that triggered an Error
								this.$refs.toastr.e('Napaka pri pošiljanju zahteve na strežnik!');
								console.log('Something happened in setting up the request that triggered an Error:', error.message);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		},
		clicl_deleteImportdata: function (importdata) {
			console.log('delete id', importdata.id);
			this.$bvModal.msgBoxConfirm('Želite izbrisati vozilo ' + importdata.ogrodje + ' (#' + importdata.id + ')?', {
				title: 'Potrdite brisanje vozila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					service.removeImportdata(importdata.id, importdata.source_file)
						.then(response => {
							if (response.message === 'deleted') {
								this.$refs.toastr.s('Vozilo ' + response.deleted_importdata.ogrodje + ' (#' + response.deleted_importdata.id + ') izbrisano.');
								this.$refs.dataTable.refresh();
							} else {
								this.$refs.toastr.e('Neveljaven odziv strežnika!');
								console.error('Neveljaven response message: ' + response.message);
							}
						})
						.catch(error => {
							if (error.response) {
								// Request made and server responded
								if (error.response.data.message === 'serverSideValidationError') {
									this.$refs.toastr.e('Napaka pri validaciji na strežniku!');
									console.error(error.response.data.message + ': ', error.response.data.errors);
								} else if (error.response.data.message === 'wrongSourceFile') {
									this.$refs.toastr.e('Brisanje je dovoljeno samo za vozila vnesena ročno!');
									console.error(error.response.data.message, 'Delete allowed only for importdata where source_file === manual, currently send: ' + error.response.data.wrong_source_file);
								} else if (error.response.data.message === 'notFoundError') {
									this.$refs.toastr.e('Vozila #' + error.response.data.wrong_deleted_id + ' ni mogoče najti!');
									console.error(error.response.data.message);
								} else if (error.response.data.message === 'notDeletedError') {
									this.$refs.toastr.e('Napaka pri brisanju vozila #' + error.response.data.wrong_deleted_id + '!');
									console.error(error.response.data.message);
								} else if (error.response.data.message === 'PDOException') {
									this.$refs.toastr.e('Napaka pri podatkovni bazi!');
									console.error(error.response.data.message, 'details in .ex');
								} else {
									this.$refs.toastr.e('Neznana napaka na strežniku!');
									console.error(error.response.data.message);
								}
							} else if (error.request) {
								// The request was made but no response was received
								this.$refs.toastr.e('Napaka: strežnik se ni odzval!');
								console.log('The request was made but no response was received:', error.request);
							} else {
								// Something happened in setting up the request that triggered an Error
								this.$refs.toastr.e('Napaka pri pošiljanju zahteve na strežnik!');
								console.log('Something happened in setting up the request that triggered an Error:', error.message);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		},
		kupciSelect_load: _.debounce((loading, search, vm) => {
			if (!vm.kupci_searchEmpty) {
				service.searchKupci(search)
					.then(kupci => {
						for (let kupec of kupci) {
							if (kupec.is_company) {
								kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
							} else {
								kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
							}
						}
						loading(false);
						vm.kupci_searched = kupci;
					})
					.catch(error => {
						loading(false);
						if (error) {
							console.log(error);
						}
					});
			} else {
				loading(false);
			}
		}, 500),
		kupciSelect_change: function (kupec) {
			if (kupec) {
				this.inputFilter.kupec = kupec.id;
			} else {
				this.inputFilter.kupec = null;
				this.kupci_searched = [...this.kupci_options];
			}
			this.$refs.dataTable.refresh();
		},
		kupciSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.kupci_searchEmpty = false;
				loading(true);
				this.kupciSelect_load(loading, search, this);
			} else if (search === '' && this.inputFilter.kupec == null) {
				this.kupci_searched = [...this.kupci_options];
				this.kupci_searchEmpty = true;
			}
		},
		toggleExportActive: function () {
			if (this.exportActive) {
				this.exportActive = false;
				for (let selectedItem of this.selectedItems) {
					selectedItem.selected = false;
				}
				this.selectedItems = [];
				this.fields.shift();
				this.fields.push({ key: 'actions', label: '#', 'class': 'tbWidthActions' });
				this.exportAll = false;
			} else {
				this.exportActive = true;
				this.fields.unshift({ key: 'selected', label: '-', sortable: false });
				this.fields.pop();
			}
		},
		exportImportData: function (ctx) {
			if (this.exportAll || this.selectedItems.length > 0) {
				this.isLoading = true;
				let data = {};
				if (this.exportAll) {
					data = {
						exportAll: this.exportAll,
						filter: this.inputFilter,
						user: this.user
					}
				} else {
					data = {
						exportAll: this.exportAll,
						items: this.selectedItems
					}
				}
				service.exportItemsData(data)
					.then(response => {
						this.isLoading = false;
						const fileLink = document.createElement('a');
						fileLink.href = URL.createObjectURL(response.data);
						fileLink.setAttribute('download', response.headers['content-disposition'].split('filename=')[1]);
						fileLink.click();
						URL.revokeObjectURL(fileLink.href);
						this.toggleExportActive();
						this.$refs.dataTable.refresh();
					})
					.catch(error => {
						this.isLoading = false;
						if (error.response) {
							// Request made and server responded
							this.$refs.toastr.e('Napaka pri izvozu vozil!');
							console.error(error);
						} else if (error.request) {
							// The request was made but no response was received
							this.$refs.toastr.e('Napaka pri izvozu vozil: strežnik se ni odzval!');
							console.error('The request was made but no response was received:', error.request);
						} else {
							// Something happened in setting up the request that triggered an Error
							this.$refs.toastr.e('Napaka pri pošiljanju zahteve za izvoz vozil-a na strežnik!');
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
			} else {
				this.$refs.toastr.e('Izbrati morate vsaj eno vozilo!');
			}
		},
		selectItem_change: function (item) {
			item.selected = !item.selected;
			if (item.selected) {
				this.selectedItems.push(item);
			} else {
				this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
			}
			this.$forceUpdate();
		},
		checkSelectedItems () {
			for (let selectedItem of this.selectedItems) {
				console.log(this.items);
				let alreadyInSelectedItems = this.items.data.find(selItem => {
					return selItem.id === selectedItem.id;
				});
				if (alreadyInSelectedItems != null) {
					alreadyInSelectedItems.selected = true;
				}
			}
		}
	},
	props: {
	},
	data: () => {
		return {
			kupci_searchEmpty: false,
			isLoading: false,
			fields: [
				{ key: 'konto_destinacije', label: 'Konto', sortable: true, 'class': 'tbWidthXSmall' },
				{ key: 'vega_dhsVegaSalesId', label: 'Vega id', headerTitle: 'Vega id', sortable: true, 'class': 'tbWidthXMedium' },
				{ key: 'st_narocila_kupca', label: 'ŠtN. kupca', headerTitle: 'Številka naročila kupca', sortable: true, 'class': 'tbWidthXMedium' },
				{ key: 'st_narocila_vozila', label: 'ŠtN. vozila', headerTitle: 'Številka naročila vozila', sortable: true, 'class': 'tbWidthXXMedium' },
				{ key: 'ogrodje', label: 'VIN', sortable: true, 'class': 'tbWidthXXMedium' },
				{ key: 'vega_brand', label: 'Znamka', sortable: true, 'class': 'tbWidthXMedium' },
				{ key: 'libelle_modele', label: 'Model', sortable: true },
				{ key: 'libelle_version', label: 'Verzija', 'class': 'tbWidthXXMedium' },
				{ key: 'libelle_options', label: 'Opcije', 'class': 'text-center tbWidthMedium' },
				{ key: 'predvideni_mada', label: 'PDP', headerTitle: 'Date dispo probable: Predviden datum prihoda', sortable: true },
				{ key: 'vega_status', label: 'Status', 'class': 'text-center' },
				{ key: 'staranje', label: 'Staranje', 'class': 'text-center tbWidthXXSmall', sortable: true },
				{ key: 'actions', label: '#', 'class': 'tbWidthActions' }
			],
			prodajalec_selected: null,
			prodajalci_options: [],
			kupec_selected: null,
			kupci_options: [],
			kupci_searched: [],
			currentPage: 1,
			perPage: 50,
			totalRows: 0,
			naviLimit: 7,
			updateTable: false,
			items: [],
			filter: null,
			inputFilter: {
				konto_destinacije: null,
				st_narocila_kupca: '',
				st_narocila_vozila: '',
				ogrodje: '',
				model: '',
				verzija: '',
				barva: '',
				staranje: '',
				stanje: null,
				status: null,
				lokacije: null,
				prodaja: null,
				prodajalec: null,
				kupec: null,
				rmadc: null,
				pmadc: null,
				omada: null,
				pdp: null,
				obljubljenaDobava: null,
				arhiv: false,
				nissan: false,
				vega_dhsVegaSalesId: '',
				vega_brand: '',
				vega_status: '',
				predvideni_mada: ''
			},
			filterImportdataTimeout: null,
			exportActive: false,
			selectedItems: [],
			exportAll: false
		};
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		isProdajaDropdownVisible () {
			if (this.inputFilter.status) {
				for (let i = 0, len = this.inputFilter.status.length; i < len; i++) {
					if (this.inputFilter.status[i] === 'prod') {
						return true;
					}
				}
			}
			return false;
		},
		isLokacijeDropdownVisible () {
			if (this.inputFilter.status) {
				for (let i = 0, len = this.inputFilter.status.length; i < len; i++) {
					if (this.inputFilter.status[i] === 'konces') {
						return true;
					}
				}
			}
			return false;
		}
	},
	created () {
		let $main = this;
		fb.db.ref('importdata').on('value', function (snapshot) {
			if ($main.updateTable) {
				$main.$refs.dataTable.refresh();
				$main.$refs.toastr.s('Podatki posodobljeni');
			}
			$main.updateTable = true;
		});
		// load prodajalci
		service.getProdajalci()
			.then(prodajalci => {
				for (let i = 0; i < prodajalci.length; i++) {
					prodajalci[i].full_name = prodajalci[i].first_name + ' ' + prodajalci[i].last_name;
				}
				prodajalci.push({
					id: -1,
					email: '',
					full_name: 'Nedodeljeno',
					first_name: 'Nedodeljeno',
					last_name: '',
					role: 0,
					fb_uid: '',
					match_pattern: '',
					created_at: '1900-01-01 00:00:01',
					updated_at: '1900-01-01 00:00:01',
					deleted_at: null
				});
				this.prodajalci_options = prodajalci;
			})
			.catch(error => {
				if (error) {
					console.log(error);
				}
			});
		// load kupci
		service.searchKupci('#initialize')
			.then(kupci => {
				for (let kupec of kupci) {
					if (kupec.is_company) {
						kupec.full_name = kupec.title + ' (' + kupec.contact_name + ')';
					} else {
						kupec.full_name = kupec.first_name + ' ' + kupec.last_name;
					}
				}
				this.kupci_options = kupci;
				this.kupci_searched = kupci;
			})
			.catch(error => {
				if (error) {
					console.log(error);
				}
			});
	}
};
</script>
<style>
.tbWidthSmall {
	width: 70px;
}
.tbWidthXSmall {
	width: 80px;
}
.tbWidthXXSmall {
	width: 120px;
}
.tbWidthMedium {
	width: 100px;
}
.tbWidthXMedium {
	width: 125px;
}
.tbWidthXXMedium {
	width: 170px;
}
.tbWidthXXXMedium {
	white-space: nowrap;
	text-overflow: ellipsis;
}
.tbWidthLarge {
	width: 200px;
}
.tbWidthActions {
	width: 245px;
}
.model_version {
	display: inline-block;
}
.i_options.fa-lg {
	font-size: 14px;
	line-height: 16px;
	vertical-align: -7%;
}
.b-table-top-row .form-control {
	padding: 0.375rem 0.375rem;
}
.advanced_filter_lokacije {
	margin-top: 18px;
}
.page-link.rows_total {
	text-align: center;
}
.opomba_input_box {
	border: 1px solid #a4b7c1;
	background-color: #f6f6f6;
	display: block;
	height: 99%;
	padding: 2px 5px;
}
.btnArhiv {
	width: 5.0rem !important;
	padding: 0.75rem 0 0.60rem 0.75rem !important;
}
.btnArhiv .custom-control {
	padding-left: 0.8rem !important;
}
.btnArhiv .custom-control-label {
	cursor: pointer;
}
.btnConfirmExport {
	width: 15.0rem !important;
	padding: 0.75rem 0 0.60rem 0.75rem !important;
}
.btnNissan {
	width: 5.5rem !important;
	padding: 0.75rem 0 0.60rem 0.75rem !important;
}
.btnNissan .custom-control {
	padding-left: 0.8rem !important;
}
.btnNissan .custom-control-label {
	cursor: pointer;
}
.nissanUpload {
	text: red;
}
</style>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Tabla.vue